import { useEffect, useRef } from 'react';
import isEqual from 'lodash/isEqual';

/**
 * Replace this with useEffect when you need to have a nested object as a dependency,
 * which would cause infinite calls (since an object is always diferent to another).
 * 
 * To address this we use isEqual to compare object references.
 */
const useEffectDeep = (effectFunc, deps) => {
  // 1. Store dependencies reference and if it's the first time it should run
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);
  const cleanup = useRef();

  useEffect(() => {
    // 2. Iterate dependencies and determine if anything has changed
    const isSame = prevDeps.current.every((dep, index) => isEqual(dep, deps[index]));
    
    // 3. Only run effect if some dep has changed or on mount
    if (isFirst.current || !isSame) {
      cleanup.current = effectFunc();
    }
    
    // 4. Update references for next call
    isFirst.current = false;
    prevDeps.current = deps;
    
    return cleanup.current;
  }, deps);
}

export default useEffectDeep;
